import React from "react";
import { SoftwareInfo } from "@sscs/types";
import { Card, LongTextLabel, ValueOrPlaceholder } from "@sscs/ui";
import {
  getClassName,
  getReleaseDateDisplay,
  prettifyLargeCount,
} from "@sscs/utils";
import styles from "./cardContent.module.scss";

type CardContentProps = {
  softwareInfo: Omit<SoftwareInfo, "architecture" | "platform">;
  description: string;
  purl?: string;
  downloadCount?: number;
  popularityRank?: number | null;
};

const CardContent = ({
  softwareInfo,
  description,
  purl,
  downloadCount,
  popularityRank,
}: CardContentProps): React.JSX.Element => {
  return (
    <Card.Content className={styles.content}>
      <dl className={styles["software-info"]}>
        {purl && (
          <>
            <dt className={styles.key}>PURL:</dt>
            <dd className={getClassName(styles.value, styles.purl)}>
              <LongTextLabel label={purl} />
            </dd>
          </>
        )}
        <dt className={styles.key}>Publisher:</dt>
        <dd className={styles.value} title={softwareInfo.publisher}>
          <ValueOrPlaceholder value={softwareInfo.publisher} />
        </dd>
        <dt className={styles.key}>Released:</dt>
        <dd
          className={styles.value}
          title={softwareInfo.release_date ?? undefined}
        >
          <ValueOrPlaceholder
            value={getReleaseDateDisplay(softwareInfo.release_date)}
          />
        </dd>
        {downloadCount !== undefined && (
          <>
            <dt className={styles.key}>Downloads:</dt>
            <dd className={styles.value}>
              {prettifyLargeCount(downloadCount)}
            </dd>
          </>
        )}
        {popularityRank !== undefined && (
          <>
            <dt className={styles.key}>Popularity:</dt>
            <dd className={styles.value}>
              <ValueOrPlaceholder
                value={popularityRank === null ? null : `#${popularityRank}`}
              />
            </dd>
          </>
        )}
      </dl>
      <div className={styles.summary}>{description}</div>
    </Card.Content>
  );
};

export default CardContent;
